import { Classification, RiskLevel } from "../types/ai";

/**
 * Live preview of the deterministic risk engine (checklist-be RiskEngine): score = L × S;
 * 1–4 Low, 5–9 Moderate, 10–16 High, 17–25 Critical; Not Determined when an input is missing.
 * The server value is always authoritative.
 */
export const assessRisk = (likelihood: number | null, severity: number | null): { score: number | null; level: RiskLevel } => {
  if (likelihood == null || severity == null) return { score: null, level: "NOT_DETERMINED" };
  const score = likelihood * severity;
  const level: RiskLevel = score <= 4 ? "LOW" : score <= 9 ? "MODERATE" : score <= 16 ? "HIGH" : "CRITICAL";
  return { score, level };
};

export const isUrgent = (classification: Classification, level: RiskLevel) => classification === "CRITICAL" || level === "CRITICAL";
